import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { MessageBubbleContainer, MessageContent } from "./SharedStyledComponents";
import WalletPaymentDialog from "../WalletPaymentDialog";

const PaymentRequestSplitPerPersonMessage = ({
  message,
  isOwn,
  currentUser,
  storedUserId,
  onOpenPaymentDialog,
  getReadReceiptStatus,
  formattedMessage,
  wrappedOnOpenPaymentDialog,
  walletPaymentDialogOpen,
  handleCloseWalletPaymentDialog,
  handleSendManualPaymentRequest,
}) => {
  const currentUserId = currentUser?.userId ?? storedUserId;
  const orderId = message?.orderId;
  const userOrders = orderId?.groupOrder?.userOrders || [];
  const currentUserOrder = userOrders.find((userOrder) => {
    const userId = userOrder.userId?._id || userOrder.userId;
    return userId === currentUserId;
  });

  const allUpfrontPaymentsComplete =
    orderId?.paymentCompleted === true ||
    (orderId?.totalPaidAmount > 0 && orderId?.paymentStatus === "paid");

  const customMessageText = formattedMessage.text;

  let messageForUserId = null;
  if (
    message.text &&
    message.text.includes("wants to pay for their own items")
  ) {
    const nameMatch = message.text.match(
      /^([^w]+)\s+wants to pay for their own items/
    );
    if (nameMatch) {
      const name = nameMatch[1].trim();
      const userForMessage = userOrders.find(
        (userOrder) => userOrder.userFullName === name
      );
      if (userForMessage) {
        messageForUserId =
          userForMessage.userId?._id || userForMessage.userId;
      }
    }
  }

  const shouldShowPayButton =
    messageForUserId === currentUserId &&
    currentUserOrder &&
    currentUserOrder.amountToPay > 0 &&
    currentUserOrder.paymentStatus !== "paid" &&
    currentUserOrder.paymentStatus !== "upfront_paid" &&
    !allUpfrontPaymentsComplete;

  const isMessagePaid =
    currentUserOrder &&
    currentUserOrder.amountToPay > 0 &&
    (currentUserOrder.amountPaid > 0 ||
      currentUserOrder.paymentStatus === "paid" ||
      currentUserOrder.paymentStatus === "upfront_paid");

  return (
    <>
      <MessageBubbleContainer isOwn={isOwn}>
        {!isOwn && (
          <Typography
            variant="caption"
            sx={{
              color: "#374151",
              fontSize: { xs: "0.75rem", sm: "0.8rem" },
              fontWeight: 600,
              mb: 0.5,
              alignSelf: "flex-start",
            }}
          >
            {message.senderId?.fullName || message.senderId?.userName || "user"}
          </Typography>
        )}

        <MessageContent
          isOwn={isOwn}
          isTemp={message.isTemp}
          isOrder={false}
          isPayment={true}
          isRequest={false}
          idDraft={false}
          isDisabled={false}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              width: "100%",
              minWidth: "280px",
              maxWidth: "380px",
              cursor: shouldShowPayButton ? "pointer" : "default",
              "&:hover": {
                opacity: shouldShowPayButton ? 0.9 : 1,
              },
            }}
          >
            <Box
              sx={{
                color: isOwn ? "#FFFFFF" : "#000000",
                fontSize: "16px",
                fontWeight: 600,
                lineHeight: 1.3,
                textAlign: "left",
              }}
            >
              {customMessageText || "Payment request"}
            </Box>

            {shouldShowPayButton && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: isOwn ? "#FFFFFF" : "#000000",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  total: ${currentUserOrder?.amountToPay || 0}
                </Typography>

                <Button
                  variant="contained"
                  disabled={isMessagePaid}
                  sx={{
                    backgroundColor: isMessagePaid ? "#9CA3AF" : "#0085FF",
                    color: "white",
                    fontWeight: 700,
                    fontSize: "16px",
                    borderRadius: 2,
                    px: 3,
                    py: 1,
                    textTransform: "none",
                    cursor: isMessagePaid ? "not-allowed" : "pointer",
                    "&:hover": {
                      backgroundColor: isMessagePaid ? "#9CA3AF" : "#0066CC",
                    },
                    "&:disabled": {
                      backgroundColor: "#9CA3AF",
                      color: "white",
                    },
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (message?.orderId?._id) {
                      wrappedOnOpenPaymentDialog(message);
                    }
                  }}
                >
                  {isMessagePaid ? "paid" : "pay"}
                </Button>
              </Box>
            )}
          </Box>
        </MessageContent>
      </MessageBubbleContainer>

      <WalletPaymentDialog
        open={walletPaymentDialogOpen}
        onClose={handleCloseWalletPaymentDialog}
        onSendManualPayment={handleSendManualPaymentRequest}
      />
    </>
  );
};

export default PaymentRequestSplitPerPersonMessage;
